import { useSeriesQuery } from '../../Series/hooks/useSeriesQuery'

export const useSeries = () => {
  const { seriesQuery } = useSeriesQuery([{ page: 1, postsType: 'video', limit: 9999 }])

  return {
    seriesQuery,
    series: seriesQuery.data?.series,
  }
}
